/**
 * Contact form component
 * 
 */

import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

// Forms

import Form from '../../components/forms/form/form';
import Input from '../../components/forms/fields/input';
import Radio from '../../components/forms/fields/radio';
import Option from '../../components/forms/fields/option';
import Textarea from '../../components/forms/fields/textarea';
import Submit from '../../components/forms/fields/submit';

class Contact extends PureComponent {

    render() {

    	const { settings, device } = this.props;
        
    	return (

    		<Form id="contact-inquiry" settings={settings} device={device}>

    			<h5>Tell me a bit about yourself</h5>

                <div className="form-column" id="inquiry-form">
                    <Input type="text" name="firstname" label="false" required="true" placeholder="First name" value="">First name</Input>
                    <Input type="text" name="lastname" label="false" required="true" placeholder="Last name" value="">Last name</Input>
                    <Input type="text" name="company" label="false" required="false" placeholder="Company" value="">Company</Input>
                    <Input type="url" name="website" label="false" required="false" placeholder="Website" value="">Website</Input>
                    <Input type="email" name="email" label="false" required="true" placeholder="Email" value="">Email</Input>
                    <Input type="tel" name="phone" label="false" required="false" placeholder="Phone" value="">Phone</Input>
                </div>

                <h5>What can I help you with?</h5>

                <Radio name="project" label="Contact request" required="true" checked="">
                    <Option value="Just saying Hello!">Just saying Hello!</Option>
                    <Option value="Branding">Branding</Option>
                    <Option value="Consulting">Consulting</Option>
                    <Option value="Marketing">Marketing</Option>
                    <Option value="UI/UX Design">UI/UX Design</Option>
                    <Option value="Development">Development</Option>
                </Radio>
                
                <h5>What is your budget?</h5>

                <Radio name="budget" label="Budget range" required="true" checked="">
                    <Option value="None">None</Option>
                    <Option value="$2,500 - $5,000">$2,500 - $5,000</Option>
                    <Option value="$5,000 - $10,000">$5,000 - $10,000</Option>
                    <Option value="$10,000 - $20,000">$10,000 - $20,000</Option>
                    <Option value="$20,000 - $30,000">$20,000 - $30,000</Option>
                    <Option value="More than $30k+">More than $30k+</Option>
                </Radio>
                
                <h5>Could you please describe your project?</h5>

                <Textarea name="message" label="false" required="true" placeholder="" value="">Project description</Textarea>

                <Input type="captcha" name="captcha" label="false" required="false" value="">Captcha</Input>
                <Input type="hidden" name="tracking" label="false" required="false" value={this.props.location.pathname}>Tracking</Input>
                <Input type="hidden" name="success" label="false" required="false" value="0">Success</Input>

                <Submit>Send Request</Submit>

    		</Form>
    	)
    }
}

export default (withRouter(Contact))



// WEBPACK FOOTER //
// ./src/components/forms/contact.js